@if (isSite()) {
  <div class="form-group">
    <label id="epsgLabel1">Site {{'EPSG.EPSG' | translate}}</label>
    <ng-select aria-labelledby="epsgLabel1"
      id="selectEPSG1"
      name="selectEPSG"
      [items]="tabEPSG$ | async"
      [multiple]="false"
      [closeOnSelect]="true"
      [searchable]="true"
      placeholder="EPSG"
      bindLabel="name"
      [(ngModel)]="epsgSelectionneSite"
      [virtualScroll]="true"
      class="custom"
      [clearable]="false"
      (change)="onSelection()"
      [minTermLength]="4"
      [typeahead]="input$"
      notFoundText="EPSG NOK"
      [loading]="epsgLoading"
      loadingText="{{'GLOBAL.CHARGEMENT' | translate}}">
    </ng-select>
    <!-- <div *ngIf="" class="custom-alert custom-alert-sm">ESPG NOK</div>
    <div *ngIf="" class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div> -->
    @if (uniteExiste() && epsgSelectionneSite()?.unite) {
      <label>{{'EPSG.UNITE' | translate}} : {{epsgSelectionneSite().unite | translate}}</label>
    }
  </div>
}

@if (isSite()) {
  <div class="form-group margin-top">
    <div class="site-coordinates">
      <span class="title">Site Coordinates</span>
      <label id="epsgLabel2">EPSG</label>
      @if (isSite()) {
        <ng-select aria-labelledby="epsgLabel2"
          [items]="tabEPSG$ | async"
          [multiple]="false"
          [closeOnSelect]="true"
          [searchable]="true"
          placeholder="EPSG"
          name="selectEPSG2"
          id="selectEPSG2"
          bindLabel="name"
          [(ngModel)]="epsgSelectionneCoordinates"
          [virtualScroll]="true"
          class="custom"
          [clearable]="false"
          (change)="onSelectionEpsgCoordinates()"
          [minTermLength]="4"
          [typeahead]="input$"
          notFoundText="EPSG NOK"
          [loading]="epsgLoading"
          loadingText="{{'GLOBAL.CHARGEMENT' | translate}}">
        </ng-select>
      }
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label id="coordXLabel">{{libelleX() | translate}}</label>
            <input aria-labelledby="coordXLabel" id="coordX" type="text" [(ngModel)]="xAffiche" name="coordX" class="form-control" placeholder="{{libelleX() | translate}}" autocomplete="off" (ngModelChange)="onUpdateX($event)" />
            @if (coordXInvalide) {
              <div class="custom-alert custom-alert-sm">{{'GLOBAL.CARACTERES_INTERDITS' | translate}}</div>
            }
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label id="coordYLabel">{{libelleY() | translate}}</label>
            <input aria-labelledby="coordYLabel" id="coordY" type="text" [(ngModel)]="yAffiche" name="coordY" class="form-control" placeholder="{{libelleY() | translate}}" autocomplete="off" (ngModelChange)="onUpdateY($event)" />
            @if (coordYInvalide) {
              <div class="custom-alert custom-alert-sm">{{'GLOBAL.CARACTERES_INTERDITS' | translate}}</div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- <div *ngIf="erreurApi" class="custom-alert custom-alert-sm">{{'GLOBAL.ERREUR_MAJ_API' | translate }}</div> -->

@if (!isSite()) {
  <div class="form-group">
    <label id="epsgLabel3">Site {{'EPSG.EPSG' | translate}}</label>
    <ng-select aria-labelledby="epsgLabel3"
      [items]="tabEPSG$ | async"
      [multiple]="false"
      [closeOnSelect]="true"
      [searchable]="true"
      placeholder="EPSG"
      name="selectEPSG3"
      id="selectEPSG3"
      bindLabel="name"
      [(ngModel)]="epsgSelectionneCoordinatesControlPoint"
      [virtualScroll]="true"
      class="custom"
      [clearable]="false"
      (change)="onSelectionCoordinatesControlPoint()"
      [minTermLength]="4"
      [typeahead]="input$"
      notFoundText="EPSG NOK"
      [loading]="epsgLoading"
      loadingText="{{'GLOBAL.CHARGEMENT' | translate}}">
    </ng-select>
    <!-- <div *ngIf="" class="custom-alert custom-alert-sm">ESPG NOK</div>
    <div *ngIf="" class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div> -->
    @if (uniteExiste() && epsgSelectionneCoordinatesControlPoint()?.unite) {
      <label>{{'EPSG.UNITE' | translate}} : {{epsgSelectionneCoordinatesControlPoint().unite | translate}}</label>
    }
  </div>
}



@if (!isSite()) {
  <div class="row">
    <div class="col-lg-4">
      <div class="form-group">
        <label id="coordXLabel2">{{libelleX() | translate}}</label>
        <input aria-labelledby="coordXLabel2" id="coordX2" type="text" [(ngModel)]="xAffiche" name="coordX" class="form-control" placeholder="{{libelleX() | translate}}" autocomplete="off" (ngModelChange)="onUpdateX($event)" />
        @if (coordXInvalide) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CARACTERES_INTERDITS' | translate}}</div>
        }
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <label id="coordYLabel2">{{libelleY() | translate}}</label>
        <input aria-labelledby="coordYLabel2" id="coordY2" type="text" [(ngModel)]="yAffiche" name="coordY" class="form-control" placeholder="{{libelleY() | translate}}" autocomplete="off" (ngModelChange)="onUpdateY($event)" />
        @if (coordYInvalide) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CARACTERES_INTERDITS' | translate}}</div>
        }
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group" >
        <label id="coordZLabel2">{{'EPSG.Z' | translate}}</label>
        <input aria-labelledby="coordZLabel2" id="coordZ2" type="text" [(ngModel)]="zAffiche" name="coordZ" class="form-control" placeholder="Z" autocomplete="off" (ngModelChange)="onUpdateZ($event)" />
        @if (coordZInvalide) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CARACTERES_INTERDITS' | translate}}</div>
        }
      </div>
    </div>
  </div>
}
